import { Routes, Route } from 'react-router-dom';

import LoginComponent from './components/login';
import LogoutComponent from './components/logout';
import OtpComponent from './components/otp';
import { EmailComponent } from './components/email';
import { LawEnforcementLandingComponent } from './components/law-enforcement/law-enforcement-landing-component';

import './components/app.css';
import CallbackComponent from './components/callback';
import { PocPlayground } from './components/poc';
import { WizardComponent } from './components/wizard/wizard-component';
import { DashboardComponent } from './components/dashboard/user-dashboard-component';
import { DeveloperAdminComponent } from './components/developer-admin';
import { LawEnforcementDashboardComponent } from './components/law-enforcement/law-enforcement-dashboard-component';
import { LawEnforcementCollisionReviewComponent } from './components/law-enforcement/law-enforcement-collision-review-component';
import { AlbertanLandingComponent } from './components/onboarding/albertan-landing-component';
import { SuperUserDashboardComponet } from './components/super-user/super-user-dashboard-component';
import { ErrorComponent } from './components/error/error-component';
import { SuperUserLandingComponent } from './components/super-user/super-user-landing-component';
import { LawEnforcementTosComponent } from './components/onboarding/law-enforcement-tos-component';
import { TokenExpiryComponent } from './components/error/token-expiry-component';

interface AppRoutesProps {}

export default function AppRoutes({}: AppRoutesProps) {
  return (
    <Routes>
      <Route path="/" element={<AlbertanLandingComponent />} />
      <Route path="/login" element={<LoginComponent />} />
      <Route path="/logout" element={<LogoutComponent />} />
      <Route path="/email/:id" element={<EmailComponent />} />
      <Route path="/otp" element={<OtpComponent />} />
      <Route path="/otp/login" element={<OtpComponent use_as_login={true} />} />
      <Route path="/callback/" element={<CallbackComponent />} />
      <Route path="/dashboard" element={<DashboardComponent />} />

      <Route path="/law/" element={<LawEnforcementLandingComponent />} />
      <Route path="/law/home" element={<LawEnforcementLandingComponent />} />
      <Route
        path="/law/dashboard"
        element={<LawEnforcementDashboardComponent />}
      />
      <Route path="/admin/dashboard" element={<SuperUserDashboardComponet />} />
      <Route path="/admin" element={<SuperUserLandingComponent />} />
      <Route path="/admin/home" element={<SuperUserLandingComponent />} />

      <Route
        path="/collision"
        element={<WizardComponent components={undefined} />}
      />
      <Route
        path="/law/collision/:collisionId"
        element={<LawEnforcementCollisionReviewComponent />}
      />

      <Route path="/law/tos" element={<LawEnforcementTosComponent />} />
      <Route path="/playground/" element={<PocPlayground />} />
      <Route path="/playground/:id" element={<PocPlayground />} />
      <Route path="/developer/" element={<DeveloperAdminComponent />} />
      <Route path="*" element={<ErrorComponent />} />
      <Route path="session-expired" element={<TokenExpiryComponent />} />
    </Routes>
  );
}
